import React from 'react';
import EditableBlock from '@/portal/components/EditableBlock.tsx';
import {
  loadEhrIntegrationSettings,
  updateEhrIntegrationSettings,
} from '@/common/api/EhrIntegrationSettings.ts';
import { EhrIntegrationSettingsData } from '@/common/types';
import EhrSettingsView from './EhrSettingsView.tsx';
import EhrSettingsEdit, { EhrSettingsFormData } from './EhrSettingsEdit.tsx';

const EhrIntegrationSettingsBlock: React.FC = () => {
  const fetchData = async (): Promise<EhrIntegrationSettingsData> => {
    return loadEhrIntegrationSettings();
  };

  const updateData = async (
    formData: Partial<EhrSettingsFormData>
  ): Promise<EhrIntegrationSettingsData> => {
    return updateEhrIntegrationSettings(formData);
  };

  const renderView = ({ data }: { data: EhrIntegrationSettingsData }) => (
    <EhrSettingsView data={data} />
  );

  const renderEdit = (props: {
    data: EhrIntegrationSettingsData;
    onSubmit: (formData: Partial<EhrSettingsFormData>) => void;
    submitRef: React.RefObject<(() => void) | null>;
  }) => <EhrSettingsEdit {...props} />;

  return (
    <EditableBlock<EhrIntegrationSettingsData, Partial<EhrSettingsFormData>>
      title="EHR Integration Settings"
      fetchData={fetchData}
      updateData={updateData}
      renderView={renderView}
      renderEdit={renderEdit}
    />
  );
};

export default EhrIntegrationSettingsBlock;
